"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FullBleed = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Box = require("../Box");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/** FullBleedProps */

/**
 * Utility to break out of parent containers
 */
var FullBleed = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "FullBleed",
  componentId: "g9qwfe-0"
})([""]);
exports.FullBleed = FullBleed;
FullBleed.defaultProps = {
  position: "relative",
  left: "50%",
  right: "50%",
  width: "100vw",
  maxWidth: "100vw",
  marginLeft: "-50vw",
  marginRight: "-50vw"
};
//# sourceMappingURL=FullBleed.js.map